export default __webpack_public_path__ + "static/media/6151dccfb85686e4.e768ccf374d8f56728c4b58a9927157c.svg";